import type { Category } from "@/types";

export const categoryMap = (categories: Category[]): Record<string, string> =>
  categories.reduce(
    (map, cat) => {
      map[String(cat.id)] = cat.name;
      return map;
    },
    {} as Record<string, string>
  );
